import { RestSlice } from '../../../../redux/rest.slice';
import { CccSite } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const siteSlice = new RestSlice<CccSite>(
	localizationService.getLocalizedString('cccSite.sites'),
	Resource.CccSites
);
export default siteSlice.rests.reducer;
